import { forwardRef, type Ref, type SVGProps } from "react";

function SvgReviewSent(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        fill="url(#review_sent_svg__a)"
        d="m57.473 90.382-5.23-2.942zm32.492 10.574-.27-5.994zM125 58c0 19.866-15.66 36.079-35.305 36.962l.54 11.988C116.261 105.779 137 84.313 137 58zM88 21c20.435 0 37 16.566 37 37h12c0-27.062-21.938-49-49-49zM51 58c0-20.434 16.566-37 37-37V9C60.938 9 39 30.938 39 58zm10.44 25.76C54.972 77.093 51 68.016 51 58H39c0 13.26 5.275 25.3 13.827 34.116zm-9.196 3.68-4.297 7.638 10.459 5.883 4.296-7.638zM54.92 107H88V95H54.92zM88 107h1.954V95H88zm1.954 0c6.236 0 8.348-8.323 2.866-11.296l-5.72 10.548C81.639 103.291 83.742 95 89.954 95zM47.947 95.078c-3 5.333.854 11.922 6.973 11.922V95c3.059 0 4.986 3.295 3.486 5.961zm4.88-2.962a3.94 3.94 0 0 1-.584-4.676l10.46 5.883c1.81-3.22 1.133-7.093-1.263-9.563zm36.868 2.846c-5.762.26-8.236 8.231-2.596 11.29l5.721-10.548c5.619 3.048 3.153 10.988-2.586 11.246z"
      />
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M88.157 45.511c.339-.681 1.347-.681 1.686 0l2.915 5.863a.93.93 0 0 0 .721.503l6.707.848c.78.1 1.092 1.024.521 1.544l-4.903 4.467a.88.88 0 0 0-.277.817l1.232 6.382c.143.743-.673 1.314-1.364.954l-5.95-3.099a.97.97 0 0 0-.89 0l-5.95 3.1c-.691.36-1.507-.212-1.364-.955l1.232-6.382a.88.88 0 0 0-.276-.817l-4.904-4.467c-.571-.52-.26-1.445.52-1.544l6.708-.848a.93.93 0 0 0 .72-.503z"
      />
      <rect width={39} height={39} x={28.5} y={10.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={28.5} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="m42.167 31.25 3.5 3.75 8.166-10"
      />
      <defs>
        <linearGradient
          id="review_sent_svg__a"
          x1={87.5}
          x2={87.5}
          y1={4.5}
          y2={110.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7DDFF" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgReviewSent);
export default ForwardRef;
